import { ChangeEvent, useState } from "react";

import { Toggle } from "@vimeo/iris/components";
import { Text } from "@vimeo/iris/typography";

import { Spinner } from "@salesforce/design-system-react";

import { Video } from "vimeo";
import { updateEmbedSettings } from "./embedSettings";

import "./common.scoped.scss";

interface Props {
    video: Video;
    onUpdate: (video: Video) => void;
    onError: (msg: string) => void;
}

export function Controls(props: Props) {
    const { video, onUpdate, onError } = props;
    const [loading, setLoading] = useState(false);

    async function onSettingsChange(e: ChangeEvent, propertyName: string) {
        setLoading(true);

        try {
            const embedSettings: any = {};
            embedSettings[propertyName] = (
                e.target as HTMLInputElement
            ).checked;
            const updatedVideo = await updateEmbedSettings(video, {
                ...embedSettings,
            });
            onUpdate(updatedVideo);
        } catch (err) {
            onError("Failed to save changes. Please try again later.");
        }

        setLoading(false);
    }

    async function onButtonSettingsChange(
        e: ChangeEvent,
        propertyName: string
    ) {
        setLoading(true);

        const buttons: any = {};
        buttons[propertyName] = (e.target as HTMLInputElement).checked;
        const updatedVideo = await updateEmbedSettings(video, {
            buttons,
        });

        onUpdate(updatedVideo);
        setLoading(false);
    }

    return (
        <>
            {loading && <Spinner />}
            <Text size={300} style={{ fontWeight: 500 }}>
                Controls
            </Text>
            <div className="toggles-container">
                <div className="slds-form-element">
                    <div className="slds-form-element__control">
                        <Toggle
                            label="Playbar"
                            checked={video.embed.playbar}
                            onChange={(e) => onSettingsChange(e, "playbar")}
                        />
                    </div>
                </div>
                <div className="slds-form-element">
                    <div className="slds-form-element__control">
                        <Toggle
                            label="Volume"
                            checked={video.embed.volume}
                            onChange={(e) => onSettingsChange(e, "volume")}
                        />
                    </div>
                </div>
                <div className="slds-form-element">
                    <div className="slds-form-element__control">
                        <Toggle
                            label="Speed controls"
                            checked={video.embed.speed}
                            onChange={(e) => onSettingsChange(e, "speed")}
                        />
                    </div>
                </div>
                <div className="slds-form-element">
                    <div className="slds-form-element__control">
                        <Toggle
                            label="Fullscreen"
                            checked={video.embed.buttons.fullscreen}
                            onChange={(e) =>
                                onButtonSettingsChange(e, "fullscreen")
                            }
                        />
                    </div>
                </div>
            </div>
        </>
    );
}
